<template>
  <component
    :is="props.to ? nuxtLink : 'div'"
    :no-prefetch="true"
    :class="[
      $style['tag'],
      { [$style['tag--shadow']]: props.shadow },
      { [$style['tag--disabled']]: !props.to },
      { [$style[`tag--${props.type}`]]: props.type },
      { [$style['tag--big']]: props.big }
    ]"
    :to="props.to">
    <div
      v-if="props.type === 'day-deal'"
      :class="$style['tag__content']">
      <div
        :class="[
          $style['tag__content__block'],
          $style['tag__content__block--first']
        ]">
        Day
      </div>
      <div
        :class="[
          $style['tag__content__block'],
          $style['tag__content__block--second']
        ]">
        deal
      </div>
    </div>
    <div
      v-else
      :class="$style['tag__content']">
      <slot />
    </div>
  </component>
</template>

<script setup>
const nuxtLink = resolveComponent('nuxt-link')
const props = defineProps({
  type: {
    type: String,
    default: null
  },
  big: {
    type: Boolean,
    default: false
  },
  shadow: {
    type: Boolean,
    default: false
  },
  to: {
    type: String,
    default: null
  }
})
</script>

<style lang="scss" module>
.tag {
    align-items: center;
    justify-content: center;
    background-color: rgba($white, .9);
    border-radius: $border-radius * 0.5;
    flex-direction: column;
    color: $black;
    display: inline-block;
    font-family: $font-heading;
    font-size: clamp($font-size-s, $font-size-m, 4.7cqw);
    line-height: 1rem;
    text-transform: uppercase;
    font-weight: $font-weight-bold;
    padding: $spacing * 0.25 $spacing * 0.5;
    text-decoration: none;
    z-index: 1;

    &__icon,
    &__content {
        display: inline-flex;
    }

    &__icon {
        padding: 0 $spacing;
    }

    &__content {
        padding: $spacing * 0.5 + 0;
    }

    &--disabled {
        pointer-events: none;
    }

    &--day-deal {
      font-size: $font-size-m;
      font-weight: $font-weight-heading;
      letter-spacing: 1px;

      .tag__content {
        display: flex;
        flex-direction: column;

        *:first-child {
          font-weight: $font-weight-normal;
          letter-spacing: 3.5px;
        }
      }

      &.tag--big {
        .tag__content {
          flex-direction: row;

          *:first-child {
            letter-spacing: 0;
          }
        }
      }
    }

    &--percentage {
        color: $white;
        border: 1px 1px 1px 0 solid $grey;
    }

    &--marble {
        background-image: url('/images/promotions/marble.webp');
        background-size: cover;
        margin-left: $spacing;
    }

    &--black-white,
    &--special,
    &--comingsoon,
    &--unavailable,
    &--backsoon {
        background-color: rgba($black, .85);

        color: $white;
        width: 100%;
        text-align: center;

        &.tag--big {
          width: auto;
        }
    }

    &--lottes-faves,
    &--sale {
        background-color: rgba($black, .85);
        color: $white;

        &.tag--big {
          box-shadow: 0 0 0 1px $black;
        }
    }

    &--day-deal,
    &--sale--day-deal {
        min-width: $spacing * 7;
        text-align: center;
    }

    &--special {
        width: auto;
    }

    &--big {
        box-shadow: 0 0 0 1px $grey;
        height: 100%;
        font-size: $font-size-m
    }

    &--shadow {
       box-shadow: 0 2px 4px 0 rgba($black,.1);
    }
}

</style>
